import gql from 'graphql-tag';

const getTransactionByOrderIdQuery = gql`
  query GetTransactionByOrderId($orderId: String!, $organisationId: String!) {
    getTransactionByOrderId(
      orderId: $orderId
      organisationId: $organisationId
    ) {
      orderId
      lineItems {
        price_data {
          unit_amount
        }
      }
      status
    }
  }
`;

export default (organisationId: string) => ({
  query: getTransactionByOrderIdQuery,
  module: 'payments',
  ignoreCache: true,
  buildVariables: ({ orderId }: { orderId: string }) => ({
    orderId,
    organisationId
  })
});
